import React from "react";
import Card from "./QuickActionsCard";

function QuickActions() {
  return (
    <div className="w-full rounded-md bg-white p-5">
      <h4 className="pb-2 font-medium">Quick Actions</h4>
      <div className="grid grid-cols-3 gap-2">
        <Card />
        <Card />
        <Card />
      </div>
    </div>
  );
}

export default QuickActions;
